"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MapLayer = _interopRequireDefault(require("../../../layers/MapLayer"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/* eslint-disable spaced-comment */
///<reference path="../../../../../../node_modules/@types/leaflet/index.d.ts" />
/* eslint-enable spaced-comment */

/**
 * `LeafletLayer` is a container class that is responsible for creating and managing a Leaflet
 * layer representation on a Leaflet map.
 */
class LeafletLayer extends _MapLayer.default {
  invalidate() {}
  createRenderable() {
    return undefined;
  }
  updateVisibility(visible) {}
  addToMap(map, index) {
    if (this.renderable) {
      this.renderable.addTo(map);
    }
  }
  removeFromMap(map) {
    if (this.renderable) {
      this.renderable.remove();
    }
  }
}
var _default = exports.default = LeafletLayer;
module.exports = exports.default;